import React from 'react'
import Formsy from 'formsy-react'
import clsx from 'clsx'
import {
  Typography,
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core'
import { FormattedMessage, useIntl } from 'react-intl'
import { FuseChipSelect } from '@fuse'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'
import useMobileStyle from 'app/components/mobileModal/mobileModalStyle'

export default (props) => {
  const {
      state,
      setState,
      classes,
      hendleAttachSubscribers,
      toggleDialogs,
      ATTACH_SUBSCRIBERS_DIALOG,
    } = props,
    { formatMessage } = useIntl()

  function handleAttachedMembersChange(value) {
    setState({
      ...state,
      attachedMembers: value,
    })
  }

  const mobileClasses = useMobileStyle()

  let suggestions = []
  if (state.membersList) {
    suggestions = state.membersList.map(({ id, firstName, lastName }) => {
      return {
        value: id,
        label: firstName + ' ' + lastName,
      }
    })
  }
  return (
    <ResponsiveDialog
      isFullScreen={false}
      classes={{ paperScrollPaper: classes.dialog_root }}
      className={mobileClasses.lessPaddingMobile}
      fullWidth
      maxWidth="sm"
      open={state.isOpenAttachSubscribersDialog}
    >
      <DialogTitle className={classes.dialog_one_title_wrapp}>
        <FormattedMessage id="group.addMember" />
        <Typography
          className={clsx(classes.dialog_one_title, 'MuiTypography-h5')}
          variant="body1"
        >
          {state.subGroupName}
        </Typography>
      </DialogTitle>

      <DialogContent className={classes.dialog_root}>
        <Formsy
          onValidSubmit={hendleAttachSubscribers}
          className="flex flex-col justify-center w-full"
        >
          <FuseChipSelect
            className="w-full my-16"
            variant="fixed"
            value={state.attachedMembers}
            onChange={handleAttachedMembersChange}
            textFieldProps={{
              label: formatMessage({ id: 'group.member.title.subscribers' }),
              InputLabelProps: {
                shrink: true,
              },
              variant: 'outlined',
            }}
            placeholder={formatMessage({ id: 'group.member.inputTxt.search' })}
            options={suggestions}
            isMulti
            required
          />

          <DialogActions>
            <Button
              onClick={() => {
                toggleDialogs(ATTACH_SUBSCRIBERS_DIALOG, false)
              }}
              className={mobileClasses.modalBtn}
            >
              <FormattedMessage id="action.cancel" />
            </Button>
            <Button
              type="submit"
              color="primary"
              className={mobileClasses.modalBtn}
            >
              <FormattedMessage id="action.save" />
            </Button>
          </DialogActions>
        </Formsy>
      </DialogContent>
    </ResponsiveDialog>
  )
}
